import { render, staticRenderFns } from "./ThreeDView.vue?vue&type=template&id=d986f976&scoped=true&"
import script from "./ThreeDView.vue?vue&type=script&lang=js&"
export * from "./ThreeDView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d986f976",
  null
  
)

export default component.exports